(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-product"] && !Shopify.designMode) return;
  try {
    
// Add to cart animation — confetti burst on click
document.addEventListener('DOMContentLoaded', function () {
  const COLS = ['#E8187A', '#7B2FBE', '#42AADC', '#FFD700', '#FF6B35', '#2ECC71'];

  document.querySelectorAll('.hhh-explore__add-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var rect = btn.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;

      for (var i = 0; i < 16; i++) {
        var p = document.createElement('div');
        var angle = Math.random() * Math.PI * 2;
        var speed = 45 + Math.random() * 75;
        var size = 5 + Math.random() * 8;
        var color = COLS[Math.floor(Math.random() * COLS.length)];

        p.style.cssText = [
          'position:fixed',
          'left:' + cx + 'px',
          'top:' + cy + 'px',
          'width:' + size + 'px',
          'height:' + size + 'px',
          'border-radius:' + (Math.random() > 0.5 ? '50%' : '3px'),
          'background:' + color,
          'pointer-events:none',
          'z-index:9999',
          'transform:translate(-50%,-50%)',
          'transition:all 0.7s cubic-bezier(0.05,0.9,0.3,1)',
          'opacity:1'
        ].join(';');

        document.body.appendChild(p);

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var tx = Math.cos(angle) * speed;
            var ty = Math.sin(angle) * speed;
            p.style.transform = 'translate(calc(-50% + ' + tx + 'px), calc(-50% + ' + ty + 'px)) rotate(' + (Math.random() * 360) + 'deg)';
            p.style.opacity = '0';
          });
        });

        setTimeout(function (el) {
          return function () { el.remove(); };
        }(p), 750);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multitab-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Clicking a holiday item sets it as active (visual only — navigation handled by href)
  var items = document.querySelectorAll('.hhh-holiday__item');
  items.forEach(function (item) {
    item.addEventListener('click', function (e) {
      // Only prevent default if no real href set (editor preview)
      var href = this.getAttribute('href');
      if (!href || href === '#' || href === '') {
        e.preventDefault();
      }
      items.forEach(function (i) { i.classList.remove('hhh-holiday__item--active'); });
      this.classList.add('hhh-holiday__item--active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
